import React, { useEffect } from 'react'

// Hooks
import { useModalContext, useBanner } from '@sketch/components'

// Components
import RestoreProject from '../../modals/RestoreProject'

// Types
import { ProjectFragment } from '@sketch/gql-types'

// Styles
import { BannerButton } from '../../components/ProjectShares/ProjectShares.styles'

interface UseProjectBannerProps {
  project?: ProjectFragment
  workspaceId: string
}

export const useProjectBanner = ({
  project,
  workspaceId,
}: UseProjectBannerProps) => {
  const { showBanner } = useBanner()
  const { showModal } = useModalContext()

  useEffect(() => {
    if (project?.deletedAt) {
      const { dismissBanner } = showBanner({
        type: 'information',
        message: (
          <>
            The <b>“{project.name}”</b> project was deleted.{' '}
            <BannerButton
              onClick={() => {
                showModal(RestoreProject, { project, workspaceId })
              }}
            >
              Restore the project
            </BannerButton>
            , to edit its documents.
          </>
        ),
      })

      return dismissBanner
    }

    if (project?.archivedAt) {
      const { dismissBanner } = showBanner({
        type: 'information',
        message: (
          <>
            The <b>“{project.name}”</b> project is archived.{' '}
          </>
        ),
      })

      return dismissBanner
    }
  }, [showModal, showBanner, project, workspaceId])
}
